import FlexColumn from "./Column";

import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('row').set({
        label: 'Flex-Zeile',
        category: blockCategories.layout,
        content: {
            type: 'row',
            classes: ['tw-row', 'flex', 'flex-wrap', 'gap-4', 'p-4'],
        },
        media: `<svg aria-hidden="true"  focusable="false" data-prefix="fas" data-icon="window-maximize" class="svg-inline--fa fa-window-maximize fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"></path></svg>`,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('row', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Row',
                tagName: 'div',
                draggable: true,
                droppable: true,
                traits: [
                    {
                        type: 'class_select',
                        options: [
                            { value: 'gap-0', name: 'No Gap' },
                            { value: 'gap-1', name: 'Gap 1' },
                            { value: 'gap-2', name: 'Gap 2' },
                            { value: 'gap-3', name: 'Gap 3' },
                            { value: 'gap-4', name: 'Gap 4' },
                        ],
                        label: 'Gap',
                        default: 'gap-4',
                    },
                    {
                        type: 'class_select',
                        name: 'layout',
                        label: 'Layout Type',
                        options: [
                            { value: 'flex-1', name: 'Equal Width' },
                            { value: 'w-auto', name: 'Auto Width' },
                            { value: 'custom', name: 'Custom Width' },
                        ],
                        default: 'flex-1',
                    },
                    {
                        type: 'class_select',
                        name: 'gap',
                        label: 'Gap Size',
                        options: [
                            { value: 'gap-2', name: 'XS (8px)' },
                            { value: 'gap-4', name: 'SM (16px)' },
                            { value: 'gap-6', name: 'MD (24px)' },
                            { value: 'gap-8', name: 'LG (32px)' },
                            { value: 'gap-12', name: 'XL (48px)' },
                        ],
                        default: 'gap-4',
                    },
                    {
                        type: 'class_select',
                        name: 'alignment',
                        label: 'Horizontal Alignment',
                        options: [
                            { value: 'justify-start', name: 'Start' },
                            { value: 'justify-center', name: 'Center' },
                            { value: 'justify-end', name: 'End' },
                            { value: 'justify-between', name: 'Space Between' },
                            { value: 'justify-around', name: 'Space Around' },
                        ],
                        default: 'justify-start',
                    },
                    {
                        type: 'class_select',
                        name: 'verticalAlign',
                        label: 'Vertical Alignment',
                        options: [
                            { value: 'items-start', name: 'Top' },
                            { value: 'items-center', name: 'Middle' },
                            { value: 'items-end', name: 'Bottom' },
                            { value: 'items-stretch', name: 'Stretch' },
                        ],
                        default: 'items-start',
                    },
                    {
                        type: 'class_select',
                        name: 'stackAt',
                        label: 'Stack Below',
                        options: [
                            { value: 'never', name: 'Never' },
                            {
                                value: 'sm:flex-row flex-col',
                                name: 'SM',
                            },
                            {
                                value: 'md:flex-row flex-col',
                                name: 'MD',
                            },
                            {
                                value: 'lg:flex-row flex-col',
                                name: 'LG',
                            },
                            {
                                value: 'xl:flex-row flex-col',
                                name: 'XL',
                            },
                        ],
                        default: 'md:flex-row flex-col',
                    },
                ].concat(defaultModel.prototype.defaults.traits),
            }),
        },
        isComponent(el) {
            if (el && el.classList && el.classList.contains('tw-row')) {
                return { type: 'row' };
            }
        },
        view: defaultView,
    });

    FlexColumn(editor);
};
